import { useQuery } from '@tanstack/react-query';
import { pricingApiConnect } from '../lib/api/pricingApi.connect';
export function usePricing(projectId, pricingId) {
    return useQuery({
        queryKey: [
            'pricing',
            projectId,
            pricingId
        ],
        queryFn: ()=>pricingApiConnect.getPricing(projectId, pricingId),
        staleTime: 30000,
        enabled: !!projectId && !!pricingId
    });
}
